import { Property } from "../../../../../models/Property";

interface SummaryStatisticsProps {
  property: Property;
}
export default function SummaryStatistics({ property }: SummaryStatisticsProps) {
  return (
    <div className='summary-page--metrics-container'>
      <h4>Site Statistics — Within 50 Miles</h4>
      <div>
        <div>{property.population ?? '--'}</div>
        <div>Population</div>
      </div>
      <div>
        <div>{property.medianSalary ?? '--'}</div>
        <div>Median Income</div>
      </div>
      <div>
        <div>{property.workforce ?? '--'}</div>
        <div>Workforce</div>
      </div>
      <div>
        <div>{property.households ?? '--'}</div>
        <div>Number of Households</div>
      </div>
    </div>
  );
}